<template>
  <div class="morePriority">
    <div class="title a-text-16 a-text-bold">更多钻石会员特权</div>
    <div class="subTitle a-text-13 a-gray t-a-c">花0.55元/天，省1209元/年</div>
    <div class="content fx-row fx-wrap">
      <div class="item t-a-c" v-for="(item, index) in list" :key="index">
        <div class="icon">
          <img :src="item.url" alt="">
        </div>
        <div class="desc a-text-12">{{item.desc}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        list:[{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/train_1@3x.png',
          desc:'首单立返50元'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/train_s_2@3x.png',
          desc:'每单返现10元'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/icon_gift@3x.png',
          desc:'99元生日礼物'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/icon_hotel@3x.png',
          desc:'酒店专享9.0折'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/speed@3x.png',
          desc:'提速宝20个/月'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/delay@3x.png',
          desc:'延误宝5个/月'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/speedup@3x.png',
          desc:'抢票加速2倍'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/carHalfPrice@3x.png',
          desc:'专车半价2次'
        },{
          url:'https://cdn.133.cn/gtgj/web/huaweiVIP/carFree@3x.png',
          desc:'专车免单1次'
        }]  
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/scss/_vars.scss';
  @import '../style/common.scss';
  .morePriority {
    color: #333;
    .title {
      position: relative;
      // width: 128*$px;
      // margin: 0 auto;
      text-align: center;
      margin-bottom: 4*$px;
      &::before {
        content: '';
        width: 48*$px;
        height: 4*$px;
        display: block;
        position: absolute;
        top: 50%;
        left: 55*$px;
        transform: translateY(-50%);
        @include bg('title_l@3x.png');
      }
      &::after {
        content: '';
        width: 48*$px;
        height: 4*$px;
        display: block;
        position: absolute;
        top: 50%;
        right: 55*$px;
        transform: translateY(-50%);
        @include bg('title_r@3x.png');
      }
    }
    .content {
      .item {
        margin-top: 20*$px;
        width: 33%;
        .icon {
          img {
            width: 28*$px;
            height: 28*$px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/huaweiVIP/components/morePriority.vue